module.exports = __webpack_public_path__ + "static/img/rgyxtq.5d596c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rgyxtq.png
// module id = PQUu
// module chunks = 1